/* Portada Belleza: al elegir una opción (color, modelo…) cambia la variante,
   repinta el precio y deja el id listo para el botón de compra de la app
   (EasySell) y para el botón "Lo quiero" del cierre. */
(function () {
  'use strict';

  function formatearPesos(centavos) {
    return '$' + Math.round(centavos / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function init(raiz) {
    if (raiz.dataset.bzListo === 'true') return;
    raiz.dataset.bzListo = 'true';

    var jsonVariantes = document.querySelector('[data-bz-variantes]');
    var jsonInicial = document.querySelector('[data-bz-inicial]');
    if (!jsonVariantes) return;

    var variantes, seleccion;
    try {
      variantes = JSON.parse(jsonVariantes.textContent);
      seleccion = jsonInicial ? JSON.parse(jsonInicial.textContent) : [];
    } catch (e) {
      return;
    }

    var elPrecio = raiz.querySelector('[data-bz-precio]');
    var elAntes = raiz.querySelector('[data-bz-antes]');
    var elOff = raiz.querySelector('[data-bz-off]');
    var elElegido = raiz.querySelector('[data-bz-elegido]');

    function buscarVariante(sel) {
      return variantes.find(function (variante) {
        return ['option1', 'option2', 'option3'].every(function (clave, i) {
          return sel[i] === undefined || variante[clave] === sel[i];
        });
      });
    }

    function pintarPrecio(variante) {
      if (!variante) return;
      if (elPrecio) elPrecio.textContent = formatearPesos(variante.price);

      var conDescuento = variante.compare_at_price && variante.compare_at_price > variante.price;
      if (elAntes) {
        elAntes.textContent = conDescuento ? formatearPesos(variante.compare_at_price) : '';
        elAntes.style.display = conDescuento ? '' : 'none';
      }
      if (elOff) {
        if (conDescuento) {
          var pct = Math.round((variante.compare_at_price - variante.price) * 100 / variante.compare_at_price);
          elOff.textContent = '-' + pct + '%';
          elOff.style.display = '';
        } else {
          elOff.style.display = 'none';
        }
      }
      // El precio del cierre sigue al del hero.
      document.querySelectorAll('[data-bz-precio-eco]').forEach(function (el) {
        el.textContent = formatearPesos(variante.price);
      });
    }

    // Deja la variante elegida visible para las apps de compra: actualiza los
    // campos ocultos y el parámetro ?variant= de la dirección.
    function avisarAApps(variante) {
      if (!variante) return;

      document.querySelectorAll('input[name="id"][data-bz-variante]').forEach(function (campo) {
        campo.value = variante.id;
      });

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variante.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {
        /* navegadores viejos: el campo oculto ya quedó actualizado */
      }

      document.dispatchEvent(new CustomEvent('bz:variante', { detail: { variante: variante } }));
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variante } }));
    }

    raiz.querySelectorAll('[data-bz-opcion]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        seleccion[parseInt(radio.dataset.indice, 10)] = radio.value;
        var variante = buscarVariante(seleccion);
        pintarPrecio(variante);
        avisarAApps(variante);
        if (elElegido) elElegido.textContent = radio.value;
      });
    });
  }

  /* Fotos de escena a sangre, fotos de producto con aire.
     No hay forma de saberlo desde Liquid, así que se mira la propia imagen:
     se copia en un lienzo de 20x20 y se muestrean sus bordes. Si están
     blancos, es una foto de producto sobre fondo blanco y se deja centrada
     con margen; si no, es una foto de ambiente y se lleva hasta el borde del
     marco. El muestreo usa una copia aparte de la imagen: si el navegador lo
     bloquea, la foto visible no se toca y todo queda como está. */
  function esFotoDeEscena(url, cuando) {
    var copia = new Image();
    copia.crossOrigin = 'anonymous';
    copia.onload = function () {
      try {
        var n = 20, c = document.createElement('canvas');
        c.width = n; c.height = n;
        var ctx = c.getContext('2d');
        ctx.drawImage(copia, 0, 0, n, n);
        var d = ctx.getImageData(0, 0, n, n).data;
        var bordes = [[0,0],[n-1,0],[0,n-1],[n-1,n-1],[n>>1,0],[n>>1,n-1],[0,n>>1],[n-1,n>>1]];
        var blancos = 0;
        bordes.forEach(function (pt) {
          var i = (pt[1] * n + pt[0]) * 4;
          if (d[i] > 242 && d[i+1] > 242 && d[i+2] > 242) blancos++;
        });
        // Solo es foto de ambiente si CASI NINGÚN borde es blanco. Un producto
        // que toque un borde no debe confundirse con una escena y recortarse.
        if (blancos <= 2) cuando();
      } catch (e) { /* lienzo bloqueado: se queda con margen */ }
    };
    copia.src = url;
  }

  function ajustarFotos() {
    document.querySelectorAll('.bz-fit-g--auto .bz-galeria__marco img').forEach(function (img) {
      if (img.dataset.bzFondo) return;
      img.dataset.bzFondo = '1';
      esFotoDeEscena(img.currentSrc || img.src, function () { img.classList.add('is-sangre'); });
    });
  }

  function arrancar() {
    document.querySelectorAll('.bz-hero').forEach(init);
    ajustarFotos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', arrancar);
})();
